/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApolloLink } from '@apollo/client';

export const contextHandlerLink = () => {
  return new ApolloLink((operation, forward) => {
    const vars = operation.variables;
    operation.setContext(({ headers }: Record<string, any>) => {
      return {
        headers: {
          ...headers,
          'ctx-site-locale': vars?.context?.locale || 'en_US',
        },
      };
    });

    return forward(operation);
  });
};
